import { NavigationManualInputData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import PropTransformer from "../PropTransformer";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const NAVIGATION_MANUAL_INPUT_DATA_TAG = 'NavManData';
class EcdisChartsTransformer extends PropTransformer {
    toGateway() {
        return undefined;
    }
    fromGateway(ecdisCharts, isUnknown, record) {
        if (ecdisCharts) {
            const chartType = (record.Entries.find((entry) => entry.Type === 'typeOfSeaChart')?.Value || '');
            const parsedEcdisCharts = JSON.parse(ecdisCharts);
            return {
                seaCharts: parsedEcdisCharts.map((chart) => ({
                    chartId: chart.freeText || '',
                    chartType: chartType,
                })),
            };
        }
        return {};
    }
}
class SeaChartsTransformer extends PropTransformer {
    toGateway(data) {
        if (data.seaCharts === undefined || data.seaCharts.length === 0) {
            return undefined;
        }
        return data.seaCharts;
    }
    fromGateway(seaCharts) {
        if (seaCharts) {
            return {
                seaCharts,
            };
        }
        return {};
    }
}
export default class NavigationManualInputParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.NAVIGATION_MANUAL_INPUT, FIXED_PROTOCOL_CONTENT_TYPE_IDS.NAVIGATION_MANUAL_INPUT, NAVIGATION_MANUAL_INPUT_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            manualPositioningObject: 'manualPositioningObject',
            manualPositioningMethod: 'manualPositioningMethod',
            manuualPositioningBearing: 'manualPositioningBearing',
            manualPositioningRange: 'manualPositioningRange',
            chartCourse: 'chartCourse',
            newOrderedCourse: 'newOrderedCourse',
            steeringMode: 'steeringMode',
            waterDensity: 'waterDensity',
            waterDepth: 'waterDepth',
            ecdisCharts: new EcdisChartsTransformer(),
            seaCharts: new SeaChartsTransformer(),
            correctionLeeway: 'correctionLeeway',
            correctionCurrent: 'correctionCurrent',
        };
    }
    createData(props) {
        return new NavigationManualInputData(props.manualPositioningObject, props.manualPositioningMethod, props.manualPositioningBearing, props.manualPositioningRange, props.chartCourse, props.newOrderedCourse, props.steeringMode, props.waterDensity, props.waterDepth, props.seaCharts, props.correctionLeeway, props.correctionCurrent);
    }
}
//# sourceMappingURL=NavigationManualInputParser.js.map